module.exports = __webpack_public_path__ + "static/media/CF.a5be9710.png";